import http from "../../backend/http.js";

async function getContact(id) {
  try {
    const response = await http.get(`crm/contacts/${id}`);
    return {
      id: response.data.id,
      name: response.data.name,
      surname: response.data.surname,
      middlename: response.data.middlename,
      emails: response.data.emails.join(","),
      phones: response.data.phones.join(","),
      position: response.data.position,
      companies: response.data.companies,
      agreements: response.data.agreements,
    };
  } catch (err) {
    throw err;
  }
}

async function updateContact(id, company) {
  try {
    const response = await http.put(`crm/contacts/${id}`, company);
    return response;
  } catch (err) {
    throw err;
  }
}

async function createContact(company) {
  try {
    const response = await http.post("crm/contacts", company);
    return response;
  } catch (err) {
    throw err;
  }
}

async function getContacts(
    page = 1,
    rowsPerPage = 9,
    search = "",
    filter = ""
) {
  try {
    const response = await http.get(
      `crm/contacts?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}${filter}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function selectContact(
    page = 1,
    rowsPerPage = 9,
    search = ""
) {
  try {
    const response = await http.get(
      "crm/contacts/references", {
        params: {
          page,
          pageSize: rowsPerPage,
          searchTerm: search,
        },
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}


export { getContact, updateContact, selectContact, getContacts, createContact };
